<!--
================================================
Un composant pour créer/modifier un projet

Url d'accès :
http://localhost:8080/fr/cronocloud-inc/projects


LIMITATION DU COMPOSANT :

 * Un erreur "vue.runtime.esm.js?2b0e:587 [Vue warn]: Error in nextTick: "TypeError: Cannot read property 'focus' of undefined"" S4affiche parfois elle est liée à focusProjectName()." Cependant le focus fonctionne bien. Je laisse comme ça pour le moment.
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
<!--    <div id="ModalProjectManagementComp">-->
<!--        {{'Hello ! :) I am ' + $options.name}}-->
<!--    </div>-->

    <div class="modal" id="ModalProjectManagementComp" v-on:keyup.esc="hideModal()" v-bind:class="{ 'is-active': isVisible, 'darkMode':themeToDisplay=='dark' }">
        <!--ajouter la classe is-active sur.modal pour l'afficher-->
        <div class="modal-background"></div>
        <div class="modal-card" >
            <header class="modal-card-head">
                <font-awesome-icon :icon="['far', 'folder-open']" class="icon"/>

                <p class="modal-card-title has-text-left">
                    <span v-if="mode== 'creation'">{{$t('CréerUnNouveauProjet')}}</span>
                    <span v-if="mode== 'edition'">{{$t('ModifierUnProjet')}}</span>

                </p>
                <button v-on:click="hideModal()" id="closeModalProjectManagement" class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">


<!--                v-on:submit.prevent évite un comportement de rechargement de la page (au lieu de soumission du form) @link https://forum.vuejs.org/t/modal-form-submit-always-reloads-page/1279-->
                <form action="" v-on:keyup.enter="validateBeforeSubmit"  v-on:submit.prevent>

                    <!--------CHAMP NAME----------------------------------->
                    <div class="field">
                        <label style="display: none" for="modalProjectManagement_name">{{$t('NomDuProjet')}}</label>
                        <input class="input projectName" type="text" v-bind:placeholder="$t('NomDuProjet')"

                               ref="projectName"
                               v-model="newProject.name"
                               v-validate="'required|max:80'"
                               data-vv-validate-on="change"
                               name="modalProjectManagement_name"
                               id="modalProjectManagement_name"
                               v-bind:class="{'is-loading':isSubmiting}"
                        >
                        <p class="help is-danger has-text-left" id="error_modalProjectManagement_name">{{errors.first('modalProjectManagement_name') }}</p>

                    </div>

                    <!--------CHAMP COLOR----------------------------------->
                    <div class="field">
                        <label class="label" for="modalProjectManagement_color">{{$t('CouleurDuProjet')}}</label>
                        <p class="help">{{$t('PermettraDitentifierVotreProjet')}}</p>

                        <project-color-selector-comp
                                v-bind:mode="mode"
                        ></project-color-selector-comp>
                        <input type="hidden" id="modalProjectManagement_color" v-model="newProject.color" name="modalProjectManagement_color" v-validate="{required:true}">
                        <p class="help is-danger has-text-left" id="error_modalProjectManagement_color">{{errors.first('modalProjectManagement_color') }}</p>

                    </div>

                    <!--------------------------------------------------------------->
                    <div class="columns settingsZone">

                        <!--------CHAMP PRIVACY----------------------------------->
<!--                        <div class="column blocPrivacy">-->

<!--                            <div class="field">-->
<!--                                <label class="label" for="modalProjectManagement_privacy">-->
<!--                                    {{$t('accès')}}-->
<!--                                </label>-->

<!--                                <input v-on:click="togglePrivacy()" id="modalProjectManagement_privacy" type="checkbox" name="modalProjectManagement_privacy" class="switch is-medium is-rounded" v-model="newProject.isPrivate" checked="checked">-->
<!--                                <label for="modalProjectManagement_privacy">-->
<!--                                    &lt;!&ndash; à afficher même vide sinon le switch n'est pas visible&ndash;&gt;-->
<!--                                    <span v-if="newProject.isPrivate" class="indicator">-->
<!--                                        <font-awesome-icon  class="icon" :icon="['fas', 'lock-alt']" />-->
<!--                                        {{$t('ProjetPrivé')}}-->
<!--                                    </span>-->
<!--                                    <span v-else class="indicator">-->
<!--                                        <font-awesome-icon  class="icon" :icon="['fas', 'lock-open']" />-->
<!--                                        {{$t('ProjetPublic')}}-->
<!--                                    </span>-->

<!--                                </label>-->
<!--                                -->
<!--                                <span class="help">-->
<!--                                     <span v-if="newProject.isPrivate">{{$t('CeProjetSeraUniquementVisibleParVous')}}</span>-->
<!--                                    <span v-else>{{$t('CeProjetSeraPublic',{'organization':this.organization.name})}} </span>-->
<!--                                </span>-->

<!--                            </div>-->
<!--                        </div>-->

                        <!--------CHAMP ARCHIVE----------------------------------->
                        <div class="column blocArchive" v-if="mode=='edition'">

                            <div class="field">
                                <label class="label" for="modalProjectManagement_archive">{{$t('archivage')}}</label>
                                <input v-on:click="toggleArchive" id="modalProjectManagement_archive" type="checkbox" name="modalProjectManagement_archive" class="switch is-medium is-rounded" v-model="reversedIsArchivedComputed" checked="checked" v-bind:class="{'isArchived':newProject.isArchived}">
                                <label for="modalProjectManagement_archive" class="archiveLabel">
                                    <!-- à afficher même vide sinon le switch n'est pas visible-->
                                    <span v-if="newProject.isArchived" class="indicator">
                                        <font-awesome-icon  class="icon" :icon="['fas', 'folder']" />
                                        {{$t('ProjetArchivé')}}
                                    </span>
                                    <span v-else class="indicator">
                                        <font-awesome-icon  class="icon" :icon="['far', 'folder-open']" />
                                        {{$t('ProjetActif')}}
                                    </span>

                                </label>

                                <span class="help">
                                     <span v-if="newProject.isArchived">{{$t('CeProjetEstArchivé')}}</span>
                                    <span v-else>{{$t('CeProjetEstActif')}}</span>
                                </span>

                            </div>
                        </div>

                    </div>

                    <!--------CHAMP CLIENT----------------------------------->
                    <div class="field clientField">
                        <label class="label" for="">{{$t('Client')}}</label>
                        <div class="control has-icons-left">

                            <div class="select"  v-bind:class="{'is-loading':isLoadingClients}">
                                <select v-model="newProject.client.slug" id="modalProjectManagement_client">
                                    <option v-bind:value="clientDefaultValue" v-bind:selected="'selected'">{{$t('sansClient')}}</option>
                                    <option v-for="(client) in clientsOrg"
                                            v-bind:key="client.slug"
                                            v-bind:value="client.slug"
                                    >{{client.name}}</option>

                                </select>
                            </div>

                            <div class="icon is-small is-left">
                                <font-awesome-icon :icon="['fas', 'user-tie']" class="icon"/>
                            </div>

                            <span class="help">{{$t('LeNomDuClientDuProjet')}}</span>

                        </div>

                    </div>

                    <!--------CHAMP INITIAL TIME IMPORT----------------------------------->

                    <div v-if="mode=='creation'" >
                        <label class="label" for="modalProjectManagement_initialTime">{{$t('importerDuTemps')}}</label>
                        <div class="field has-addons initialTime">

                            <div class="control has-icons-left">
                                <input class="input projectInitialTime" type="number" min="0" max="999999" v-bind:placeholder="'0 h'"

                                       tabindex="0"
                                       v-model="newProject.initialTime"
                                       v-validate="'numeric|max_value:999999'"
                                       data-vv-validate-on="change"
                                       name="modalProjectManagement_initialTime"
                                       id="modalProjectManagement_initialTime"
                                       v-bind:class="{'is-loading':isSubmiting}"
                                >
                                <font-awesome-icon :icon="['fas', 'hourglass-half']" class="icon is-left"/>
                            </div>

                            <div class="control inputAddonLabel">
                                <a class="button is-static">{{$t('heuresÀImporter')}}</a>
                            </div>
                        </div>
                        <p class="help is-danger has-text-left" id="error_modalProjectManagement_initialTime">
                            {{errors.first('modalProjectManagement_initialTime') }}</p>
                        <p class="help has-text-left">{{$t('ImporterDuTempsDetails') }}</p>
                    </div>

                  <!--------CHAMP ESTIMATE----------------------------------->

                  <!-- On peut editer le projet si on est ROLE_ADMIN ou que l'on est le propriétaire (en mode édition)-->
                  <div class="contEstimate" v-if="$auth.hasRole('ROLE_ADMIN') || mode
                   =='edition' &&  newProject.owner.slug== $auth.getUserSlug() " >
                    <label class="label" for="modalProjectManagement_estimate">{{$t('TempsPrévu(Heures)')}}</label>
                    <div class="field  estimate">

                      <div class="control has-icons-left">
                        <input class="input estimate" type="number" min="0" max="999999" v-bind:placeholder="'0 h'"

                               tabindex="0"
                               v-model="newProject.estimate"
                               v-validate="'numeric|max_value:999999'"
                               data-vv-validate-on="change"
                               name="modalProjectManagement_estimate"
                               id="modalProjectManagement_estimate"
                               v-bind:class="{'is-loading':isSubmiting}"
                        >
                        <font-awesome-icon :icon="['fas', 'hourglass-half']" class="icon is-left"/>
                      </div>

                    </div>
                    <p class="help is-danger has-text-left" id="error_modalProjectManagement_estimate">
                      {{errors.first('modalProjectManagement_estimate') }}</p>
                    <p class="help has-text-left">{{$t('projetEstimationDetails') }}</p>
                  </div>


                    <!--//////////////////////////////////// -->

                </form>

            </section>
            <footer class="modal-card-foot">
                <a v-on:click="hideModal()" class="button is-text cancelLink">{{$t("annuler")}}</a>
                <a v-on:click="validateBeforeSubmit()" v-bind:class="{'is-loading':isSubmiting}" v-bind:disabled="isSubmiting"
                   class="button is-primary validBtn " id="submitModalProjectManagement" >{{$t("valider")}}</a>
            </footer>

        </div>

    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import _ from 'lodash'
    import ProjectColorSelectorComp from "@/components/ProjectColorSelectorComp.vue";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'ModalProjectManagementComp', //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, TrackingMixin],

        components: {ProjectColorSelectorComp},

        props: {
            project : Object, // un objet project à éditer, si vide alors le composant est en mode création, sinon en mode édition //@todo vérifier si utilisé mais à priori non, à supprimer
        },
        data: function () {
            return {
                locale : this.$route.params.locale,
                mode: 'creation', // String le mode dans lequel on utilise la modale : 'creation/edition'
                isVisible: false, // bool | la visibilité de la modale
                isSubmiting: false,
                clientsOrg: [], // Array | la liste des clients de l'organization
                isLoadingClients: true, //bool vaut true si la


                // NOTE : GARDER  newProject SYNCHRO AVEC resetProject() !
                newProject: // L'objet du nouveau projet à créer
                    {
                    name: null , // String | le nom du projet
                    isPrivate: true, // Bool si true le projet est privé
                    isArchived: false, // Bool si true le projet est archivé
                    color: null, // String le code hexadécimal de la couleur du projet (ex 90a4ae) @see ProjectColorSelectorComp.colors
                    client: {
                        name: null, // string nom du client auquel lier le projet
                        slug: null,// string slug du client auquel lier le projet
                    },
                    initialTime: null, // int Un nombre d'heure à importer à la création du projet
                    estimate: null, // int Le nombre d'heure prévu pour le projet
                },
                clientDefaultValue: 'aucun_client_value', // String la valeur de l'option  'client' lorsqu'aucun client n'est sélectionné


                // pour les composants où l'user est identifié ///////////////////////
                organizationSlug: this.$route.params.organization
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
                // componentIsReady : false, // indique quand le composant est prêt à être afficher
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                // user: state => state.user
                organization: state => state.organization,
                themeToDisplay: state => state.app.themeToDisplay

            }),

            //----------------------------------------------

            // other computed props :
            reversedIsArchivedComputed: {
                get: function () { return !this.newProject.isArchived;},
                set: function (newValue) {
                  // this.reversedIsArchived = newValue
                }
            }

          // checkedItem: {
          //   get: function () {
          //     return !this.comb['inactive'];
          //   },
          //   set: function (newVal) {
          //     console.log("set as you want")
          //   }

        },
        // watch: {
        //     // à chaque fois que la prop computed user change, cette fonction s'exécutera
        //     user: function () {
        //     }
        // },


        methods: {

            /**
             * Focus le champ project name
             * Inspiré de https://stackoverflow.com/questions/52088691/vue-js-put-focus-on-input
             **/
            focusProjectName() {
                this.$nextTick(() => {
                    this.$refs.projectName.focus()
                });
            },

            /*
            * Affiche la modale
            */
            showModal(){
                this.isVisible = true
                this.focusProjectName()
            },

            /*
            * Masque la modale
            */
            hideModal(){
                this.isVisible = false
                this.isSubmiting=false
                this.resetProject()
            },

            /**
             * Définit toute les propriété de l'objet passé à null
             *
             * Cette sert lorsque l'on ferme la modal puis qu'on la ré-ouvre évite que les informations de l'ouverture précédente restent affichées.
             */
            resetProject(){
                this.newProject.client = {name: null, slug: null}
                this.newProject.isPrivate = false
                this.newProject.isArchived = false
                // this.newProject.color = null // on garde la couleur car évite un bug qui affiche une erreur couleur vide dans modal Project management (@link https://gitlab.com/ousmane1/kronocloud/issues/239)
                this.newProject.name = null
            },

            /*
              Toggle la property isPrivate
            */
            togglePrivacy() {
                if (this.newProject.isPrivate=== true) {
                    this.newProject.isPrivate= false
                } else {
                    this.newProject.isPrivate= true
                }
            },
            /*
              Toggle la property isArchived
            */
            toggleArchive() {
                if (this.newProject.isArchived=== true) {
                    this.newProject.isArchived= false
                } else {
                    this.newProject.isArchived= true
                }
            },

            /**
             * Récupère les clients de l'organization
             **/
            LoadOrganizationClients(){

                let self = this;
                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/clients`,
                    {
                        params: {sort:"desc"},
                        headers: {Authorization: self.$auth.header()},
                        timeout: 20000 // surcharge timeout car la requête a tendance à prendre du temps @todo à améliorer à terme ?

                    }
                )
                    .then(function (response) {
                      self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                      self.clientsOrg = response.data
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')

                            let errorCode = '0026b'
                            self.showGlobalErrorNotif(self, errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error fetching organization clients', 'fatal': false})

                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error fetching organization clients"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error fetching organization clients : ${error}`, 'error')

                        }
                    })
                    .then(function () {
                        self.isLoadingClients= false
                    })

            },


            /**
             * Valide le form avant soumission
             **/
            validateBeforeSubmit(){

                let self =this;
                this.$validator.validateAll().then((result) => {
                    if (result) { // si la validation. réussie
                            switch (self.mode) {
                                case  'creation':
                                    self.sendCreateQuery()
                                    break;
                                case 'edition':
                                    self.sendEditQuery()
                                    break;
                            }
                    }
                    else{ // si il y a des erreurs...
                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-danger',
                            'message': self.$t('leFormulaireContientDesErreurs')
                        });
                    }

                })
            }


            /**
             * Permet de définir client à null s'il est égal à la valeur 'sans client' du select (aucun_client_value). Pour ne pas envoyer une valeur non attendue à l'api.
             * @param client String la valeur du champ value de la liste de choix du client (slug client)
             * */
            ,sanitizeClient(clientSlug){
                if(clientSlug == this.clientDefaultValue){
                    return null
                }
                else{
                    return clientSlug
                }

            }

            /**
             * Envoie la requête post de création d'un projet
             * @return {Promise<{} | never>}
             */
            ,sendCreateQuery(){

                this.isSubmiting = true;

                let self = this
                return self.$http
                    .post(`/organizations/${self.organizationSlug}/projects`,
                        {

                            name: self.newProject.name,
                            isArchived: self.newProject.isArchived,
                            isPrivate: self.newProject.isPrivate,
                            color: self.newProject.color,
                            client: self.sanitizeClient(self.newProject.client.slug),
                            estimate:self.newProject.estimate,
                            initialTime: self.newProject.initialTime,
                            workspaces: [self.$auth.getActiveWorkspace()] //@todo dynamiser dans #290 https://gitlab.com/ousmane1/kronocloud/-/issues/290
                        },
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on envoie un event pour dire au ProjectSelectorComp de maj les projets
                        self.$root.$emit('new_project_added',response.data)

                        // on Définit le projet qui sera sélectionné dans NewTaskComp
                        self.$root.$emit('project_selected',response.data, 'NewTaskComp') // le projet est émit depuis le NewTaskComp (pour rappel il y a 2 project-selector-comp un dans NewTaskComp et l'autre dans ModalTaskTimerecordsEditionComp)

                        self.hideModal()

                        // tracking mixpanel
                        if(self.newProject.initialTime != null){
                            self.$mixpanel.track("Project created (with time import)", {"timerecord":response.data.slug, "importedTime":self.newProject.initialTime });
                          self.ga4GlobalEventTrack('Project created' , {event_label: 'with time import',value:self.newProject.initialTime})


                        }
                        else{
                          self.ga4GlobalEventTrack('Project created' , {})
                          self.$mixpanel.track("Project created", {"timerecord":response.data.slug});
                        }

                        return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                          // si le code est "payment required"
                          if (error.response.status === 402) {
                            self.$root.$emit('show_modal_premium_limitation', 'limit',
                            self.$t('LimiteAtteinte')+'...', self.$t('limit-VousSouhaitezCréerDavantageDeProjet'), self.$t('MettezVotreAboÀNiveauVersPlusOuMax'));

                            // tracking
                            let trackingLabel ='Premium limitation modal displayed'
                            self.ga4GlobalEventTrack(trackingLabel , {})
                            self.$mixpanel.track(trackingLabel, {"feat":error.response.data.feat})
                          }
                        else{
                            self.logToSentry(self, error, 'error')

                            let errorCode = '0027b'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error creating project', 'fatal': false})

                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error creating project"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error creating project : ${error}`, 'error')
                          }

                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            }

            /**
             * Envoie la requête patch de modification d'un projet
             * @return {Promise<{} | never>}
             */
            ,sendEditQuery(){
                this.isSubmiting = true;

                let self = this
                return self.$http
                    .patch(`/organizations/${self.organizationSlug}/projects/${self.newProject.slug}`,
                        {
                            name: self.newProject.name,
                            isArchived: self.newProject.isArchived,
                            isPrivate: self.newProject.isPrivate,
                            color: self.newProject.color,
                            client: self.sanitizeClient(self.newProject.client.slug),
                            estimate: self.newProject.estimate,
                        },
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on envoie un event pour dire au ProjectListComp de maj les projets
                        self.$root.$emit('project_edited',response.data)

                        self.hideModal()

                        // tracking mixpanel
                        self.$mixpanel.track("Project edited", {"timerecord":response.data.slug});
                        self.ga4GlobalEventTrack('Project edited' , {})

                      return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0028'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error editing project', 'fatal': false})

                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error editing project"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error editing project : ${error}`, 'error')
                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            },

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
            // this.logToSentry(this, 'push a log to sentry :)', 'info')

            this.newProject.client.slug= this.clientDefaultValue // initialisation du select client

            // on charge la liste de clients de l'organization
            this.LoadOrganizationClients()

            /*
             * Event show_modal_project_management, déclenche l'affichage de la modale
             * @param mode String (edition/creation)
             * @param project L'objet project (dans le cas du mode edition)
             */
            this.$root.$on('show_modal_project_management', (mode, project) => {


                this.mode = mode // on définit le mode de la modale

                switch (mode) {
                    // mode creation pré-remplissage du nom du projet
                    case  'creation': {

                        if (project != null) {
                            this.newProject.name = project.name
                        }
                        break;
                    }
                    // mode edition : hydratation de la modal avec le projet à modifier
                    case 'edition': {

                        // ici on clone l'objet project (sinon altère le projet dans le ProjectListComp)
                        let clone = _.clone(project)
                        this.newProject = clone

                        // si le client est null on en créé un vide, avec la valeur clientDefaultValue
                        if (project.client == null) {
                            this.newProject.client = {slug: this.clientDefaultValue, name: null}
                        }
                    }
                    break;
                }

                this.showModal()
            })

            /*
             * Listener de l'event project_color_selected du composant ProjectColorSelectorComp
             * @param color String (code hexa.)
             */
            this.$root.$on('project_color_selected', (color) => {
                this.newProject.color = color.code
            })

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    .modal {


      .modal-card-head .icon {
        margin-right: 0.5rem;
        color: $brandFourth;
      }

      .field {
        margin-bottom: 1.5rem;
      }

      .label {
        margin-bottom: 0;
      }

      .help {
        margin-top: 0;
      }

      .settingsZone {
        /*border-bottom: solid 1px #eee;*/
        /*border-top: solid 1px #eee;*/
        /*padding: 0.5rem 0;*/

        label {
          margin-bottom: 0.5rem;
          /*text-transform: capitalize;*/
          .indicator {
            font-size: 1rem;
          }
        }
      }

      .blocPrivacy {
      }

      .blocArchive {
      }

      .clientField {
        .icon {
          height: 1.1rem;
          margin-top: 0.3rem;
        }
      }

      .initialTime.field {
        margin-bottom: 0.5rem;

        .inputAddonLabel {
          a {
            font-size: .9rem;
            padding: 1.4rem 0.8rem;
          }
        }

        #modalProjectManagement_initialTime {
          padding-left: 2rem;
          .icon{
          }


        }

        .icon {
          color: #ccc;
          margin-top: 0.9rem;
          height: 1.1rem;
        }
      }

      .contEstimate{
        margin-top: 2rem;
        .estimate.field {

          margin: .5rem 0;

          .bgEStimateLabel {
            a {
              padding: 1.4rem 0.5rem;
            }
          }

          #modalProjectManagement_estimate {
            padding-left: 2rem;
            .icon{
            }
          }

          .icon {
            color: #ccc;
            margin-top: 0.9rem;
            height: 1.1rem;
          }
        }

      }

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {
        label {
          .indicator {
            color: $darkLightBlue;
          }
        }


        $iconColor: #666;
        .clientField {
          .icon {
            color: $iconColor;
          }
        }

        .initialTime.field {
          .icon{
            color: $iconColor;
          }
          .inputAddonLabel{
            a{
              background-color: $darkBg4 !important;
              color:#999;
              border-color: lighten($darkBg3,15%) !important;
            }
          }
        }

        .estimate.field{
          .icon {
            color:$iconColor;
          }

        }

      }


    }
</style>
